import { render, staticRenderFns } from "./newTaskOrder.vue?vue&type=template&id=65c1a310&scoped=true"
import script from "./newTaskOrder.vue?vue&type=script&lang=js"
export * from "./newTaskOrder.vue?vue&type=script&lang=js"
import style0 from "./newTaskOrder.vue?vue&type=style&index=0&id=65c1a310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c1a310",
  null
  
)

export default component.exports